import { HttpClient } from 'core/common/services';
import { stringifyQueryParams } from 'core/common/utils/getQueryParams';
import { NatalChartBlockValuesPayload, NatalChartBlockValue } from '../../entities';
import { ContentServiceInterface } from '../../interfaces';
import { NatalChartContentMapper } from '../../mappers';
import { BlockValueDto } from './dto';

export class ContentService implements ContentServiceInterface {
  constructor(private readonly httpClient: HttpClient) {}

  async getNatalChartBlockValues(
    payload: NatalChartBlockValuesPayload,
  ): Promise<NatalChartBlockValue[]> {
    const mapper = new NatalChartContentMapper();

    const { data } = await this.httpClient.get<BlockValueDto[]>(`/content-selector/block-values`, {
      params: payload,
      paramsSerializer: (params) => stringifyQueryParams(params, 'brackets'),
    });

    return data.map(mapper.toEntity);
  }
}
